import user from './allApi/user';
import list from './allApi/list';
import data from './allApi/data';
import record from './allApi/record';
import system from './allApi/system';

export default { system, user, list, data, record };
